// extracted by mini-css-extract-plugin
export var base = "_2c-0";
export var updateBanner = "_2c-1";